export default __webpack_public_path__ + "static/media/Bill Huizenga.65e0976b.jpg";